import { render, staticRenderFns } from "./SpecialQuestion.vue?vue&type=template&id=2316a2aa&scoped=true"
import script from "./SpecialQuestion.vue?vue&type=script&lang=js"
export * from "./SpecialQuestion.vue?vue&type=script&lang=js"
import style0 from "./SpecialQuestion.vue?vue&type=style&index=0&id=2316a2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316a2aa",
  null
  
)

export default component.exports